import { gql } from '@apollo/client'

export const UPLOAD_FILES = gql`
    mutation UploadFiles(
        $files: [FileUpload!]!
        $uploadId: String!
        $campaignId: ID!
        $adId: ID
        $replaceExisting: Boolean = false
        $formats: [String]
        $allowMultiple: Boolean!
        $source: String
    ) {
        uploadFiles(
            files: $files
            uploadId: $uploadId
            campaignId: $campaignId
            adId: $adId
            replaceExisting: $replaceExisting
            formats: $formats
            allowMultiple: $allowMultiple
            source: $source
        )
    }
`

export const DELETE_AD_ASSET = gql`
    mutation DeleteAdAsset($id: ID!) {
        deleteAdAsset(id: $id)
    }
`

export const GET_AD_ASSETS = gql`
    query GetAdAssets($campaignId: ID, $adId: ID, $hasMetaId: Boolean, $source: String) {
        AdAsset {
            adAssets(campaignId: $campaignId, adId: $adId, hasMetaId: $hasMetaId, source: $source) {
                id
                name
                url
                mime_type
                size
                width
                height
                source
                source_id
                thumbnails {
                    width
                    height
                    url
                }
                variations {
                    id
                    ad_creative_asset_id
                    format
                    cropped
                    crop_data
                    created_at
                    updated_at
                }
                trim_data {
                    start
                    end
                }
                type
                status
                duration
                position
                headline
                description
                image_alt_text
                created_at
                updated_at
            }
        }
    }
`

export const AD_ASSET_UPLOAD_SUBSCRIPTION = gql`
    subscription AdAssetUpload($uploadId: String!) {
        adAssetUpload(uploadId: $uploadId) {
            uploadId
            uploadedKB
            totalKB
            fileId
            state
            width
            height
            url
            newId
            error
            type
            thumbnails {
                width
                height
                url
            }
        }
    }
`

export const CANCEL_UPLOAD = gql`
    mutation CancelUpload($ids: [ID!]!) {
        cancelUpload(ids: $ids)
    }
`

export const GET_AD_ASSET_BY_ID = gql`
    query AdAsset($id: ID!) {
        AdAsset {
            adAsset(id: $id) {
                id
                name
                url
                width
                height
                duration
                type
                status
                thumbnails {
                    width
                    height
                    url
                }
                trim_data {
                    start
                    end
                }
                variations {
                    id
                    ad_creative_asset_id
                    format
                    cropped
                    crop_data
                    created_at
                    updated_at
                }
            }
        }
    }
`

export const UPDATE_AD_ASSET_THUMBNAIL = gql`
    mutation UpdateAdAssetVideoThumbnail($assetId: ID!, $frameId: Int!) {
        updateAdAssetVideoThumbnail(assetId: $assetId, frameId: $frameId)
    }
`

export const UPDATE_AD_ASSET_CROP_DATA = gql`
    mutation UpdateAdAssetCropData($assetId: ID!, $cropData: CropDataInput!) {
        updateAdAssetCropData(assetId: $assetId, cropData: $cropData)
    }
`

export const UPDATE_AD_ASSET_TRIM_DATA = gql`
    mutation UpdateAdAssetTrimData($assetId: ID!, $trimData: TrimDataInput!) {
        updateAdAssetTrimData(assetId: $assetId, trimData: $trimData)
    }
`

export const GET_ASSET_STATUS = gql`
    query AssetStatus($id: ID!) {
        AdAsset {
            adAsset(id: $id) {
                id
                status
                type
            }
        }
    }
`

export const GET_VIDEO_THUMBNAILS = gql`
    query VideoThumbnails($assetId: ID!) {
        AdAsset {
            videoThumbnails(assetId: $assetId) {
                id
                url
                timestamp
                formattedTime
            }
        }
    }
`

export const UPDATE_AD_ASSET_POSITIONS = gql`
    mutation UpdateAdAssetPositions($updates: [AdAssetPositionInput!]!) {
        updateAdAssetPositions(updates: $updates) {
            id
            position
        }
    }
`

export const UPDATE_AD_ASSET_DETAILS = gql`
    mutation UpdateAdAssetDetails($assetId: ID!, $headline: String, $description: String, $image_alt_text: String) {
        updateAdAssetDetails(
            assetId: $assetId
            headline: $headline
            description: $description
            image_alt_text: $image_alt_text
        ) {
            id
            headline
            description
            image_alt_text
        }
    }
`

export const GET_AD_CREATIVE_ASSET_VARATIONS_BY_AD_CREATIVE_ID = gql`
    query GetByAdCreativeId($adCreativeId: ID!) {
        AdCreativeAssetVariation {
            getByAdCreativeId(adCreativeId: $adCreativeId) {
                id
                ad_creative_asset_id
                format
                cropped
                crop_data
                adCreativeAsset {
                    id
                    name
                    url
                    height
                    width
                    mime_type
                    size
                    type
                    duration
                    trim_data {
                        start
                        end
                    }
                    thumbnails {
                        height
                        width
                        url
                    }
                }
            }
        }
    }
`

export const GET_AD_CREATIVE_ASSET_VARATIONS_BY_AD_CREATIVE_ASSET_ID = gql`
    query GetByAdCreativeAssetId($adCreativeAssetId: ID!) {
        AdCreativeAssetVariation {
            getByAdCreativeAssetId(adCreativeAssetId: $adCreativeAssetId) {
                id
                ad_creative_asset_id
                format
                cropped
                crop_data
                adCreativeAsset {
                    id
                    name
                    url
                    height
                    width
                    mime_type
                    size
                    type
                    thumbnails {
                        height
                        width
                        url
                    }
                }
            }
        }
    }
`
